module.exports = __webpack_public_path__ + "img/sprite.6f8d6522.svg";